<div class="p-6">
    <!-- Header -->
    <div class="flex items-start gap-3 mb-5">
        <div class="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5 text-blue-600">directions_car</mat-icon>
        </div>
        <div>
            <h2 class="text-base font-semibold text-slate-900">{{ 'parkingRight.poolCap.title' | translate }}</h2>
            <p class="text-sm text-slate-500 mt-0.5">{{ data.parkingSpace.name }}</p>
        </div>
    </div>

    @if (isLoading()) {
    <div class="flex justify-center py-10">
        <mat-spinner diameter="32"></mat-spinner>
    </div>
    } @else if (error()) {
    <div class="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">{{ error() }}</div>
    } @else if (result(); as r) {
    <div class="flex items-center gap-2 mb-3">
        <span class="text-xs font-semibold px-2 py-0.5 rounded-full"
            [class]="r.applied ? 'bg-green-50 text-green-700' : 'bg-slate-100 text-slate-600'">
            {{ (r.applied ? 'parkingRight.poolCap.applied' : 'parkingRight.poolCap.preview') | translate }}
        </span>
        <span class="text-xs text-slate-500">{{ 'parkingRight.poolCap.cap' | translate }}: {{ r.maxCarsAllowed }}</span>
    </div>

    <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
        <div class="rounded-xl border border-slate-200 p-3">
            <div class="text-xs text-slate-500">{{ 'parkingRight.poolCap.rightsFound' | translate }}</div>
            <div class="text-lg font-semibold text-slate-900">{{ r.rightsFound }}</div>
        </div>
        <div class="rounded-xl border border-slate-200 p-3">
            <div class="text-xs text-slate-500">{{ 'parkingRight.poolCap.rightsLinked' | translate }}</div>
            <div class="text-lg font-semibold text-blue-600">{{ r.rightsLinked }}</div>
        </div>
        <div class="rounded-xl border border-slate-200 p-3">
            <div class="text-xs text-slate-500">{{ 'parkingRight.poolCap.configsCreated' | translate }}</div>
            <div class="text-lg font-semibold text-slate-900">{{ r.configsCreated }}</div>
        </div>
        <div class="rounded-xl border border-slate-200 p-3">
            <div class="text-xs text-slate-500">{{ 'parkingRight.poolCap.skippedSupplier' | translate }}</div>
            <div class="text-lg font-semibold text-slate-900">{{ r.skippedSupplier }}</div>
        </div>
        <div class="rounded-xl border border-slate-200 p-3">
            <div class="text-xs text-slate-500">{{ 'parkingRight.poolCap.skippedNoOwner' | translate }}</div>
            <div class="text-lg font-semibold text-slate-900">{{ r.skippedNoOwner }}</div>
        </div>
        <div class="rounded-xl border border-slate-200 p-3">
            <div class="text-xs text-slate-500">{{ 'parkingRight.poolCap.skippedNotRegistered' | translate }}</div>
            <div class="text-lg font-semibold text-slate-900">{{ r.skippedNotRegistered }}</div>
        </div>
        @if (r.applied) {
        <div class="rounded-xl border border-slate-200 p-3">
            <div class="text-xs text-slate-500">{{ 'parkingRight.poolCap.configsSynced' | translate }}</div>
            <div class="text-lg font-semibold text-slate-900">{{ r.configsSyncedToCap }}</div>
        </div>
        }
    </div>

    @if (r.failures?.length) {
    <div class="mt-4 rounded-xl border border-red-200 bg-red-50 p-3">
        <div class="text-xs font-semibold text-red-700 mb-1">
            {{ 'parkingRight.poolCap.failures' | translate }} ({{ r.failures!.length }})
        </div>
        <ul class="text-xs text-red-700 max-h-40 overflow-auto list-disc pl-4">
            @for (failure of r.failures; track $index) {
            <li>{{ failure }}</li>
            }
        </ul>
    </div>
    }
    }

    <!-- Actions -->
    <div class="flex justify-end gap-2 mt-6">
        <jjames-button variant="secondary" (clicked)="close()">{{ 'parkingRight.poolCap.close' | translate }}</jjames-button>
        @if (result() && !result()!.applied && result()!.rightsLinked) {
        <jjames-button variant="primary" matIconLeft="done_all" [loading]="isLoading()" [disabled]="isLoading()"
            (clicked)="apply()">{{ 'parkingRight.poolCap.apply' | translate }}</jjames-button>
        }
    </div>
</div>
